import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take, startWith, map } from 'rxjs/operators';
import { FormGroup, FormControl } from '@angular/forms';
import { ConferenciaVolumeService } from 'src/app/services/confVolume/conferencia-volume.service';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { ClienteInput, ClienteOutput } from 'src/app/@shared/models/cliente.model';

@Component({
  selector: 'app-cliente-autocomplete',
  templateUrl: './cliente-autocomplete.component.html',
  styleUrls: ['./cliente-autocomplete.component.scss']
})
export class ClienteAutocompleteComponent implements OnInit {
  @Input('clienteRisco') clienteRisco: boolean = false;
  @Output() clienteIdOutput = new EventEmitter();
  @Input() form: FormGroup;
  filteredOptions: Observable<any[]>;
  options: any;
  clienteId: number;
  public paging = { index: 0, size: 10, length: 0 };
  // filterForm = new FormGroup({
  //   clienteFormControl: new FormControl()
  // });
  get clienteFormControl() { return this.form.get('clienteFormControl').value; }

  constructor(
    public snackBar: MatSnackBar,
    private clienteService: ClienteService,
    private conferenciaVolumeService: ConferenciaVolumeService,
  ) { }

  ngOnInit() {
    this.getAllClientes();
  }

  getAllClientes() {
    if (this.clienteRisco) {
      this.conferenciaVolumeService.ListarClientesRisco().subscribe(
        response => {
          this.options = response;
          this.filteredOptions = this.form.controls['clienteFormControl'].valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        }
      );

    } else {
      const clienteInput = {
        nome: this.clienteFormControl,
        paginaAtual: this.paging.index + 1,
        itensPorPagina: 1000000
      } as ClienteInput;

      this.clienteService.getAllClientes(clienteInput)
        .pipe(take(1))
        .subscribe(
          (response: HttpResponse<ClienteOutput[]>) => {
            this.options = response.body;
            if (response.body.length > 0) {
              this.filteredOptions = this.form.controls['clienteFormControl'].valueChanges
                .pipe(
                  startWith(''),
                  map(value => this._filter(value))
                );
            }
          },
          (err: HttpErrorResponse) => {
            console.error(err);
            this.openSnackBar('Erro ao carregar listagem!', 'OK', 5000, 'danger-snackbar');
          });
    }
  }

  private _filter(value: string): string[] {
    if (value && this.options) {
      const filterValue = value.toLowerCase();
      return this.options.filter(option => option.nome.toLowerCase().includes(filterValue));
    }
    return null;
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  setCliente(selectedOption) {
    this.clienteId = this.clienteRisco ? selectedOption.clienteID : selectedOption.id;
    this.clienteIdOutput.emit(this.clienteId ?? null);
  }

  changeCallback() {
    if (!this.clienteFormControl) {
      this.clienteIdOutput.emit(null);
    }
  }
}
